
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';
import fa from 'vuetify/src/locale/fa';

@Component
export default class Merchant extends Vue {
  public formTitle = 'مدیریت سیم کارت ها';
  public importFormTitle = 'افزودن گروهی سیم کارت ها';
  public desserts = [];
  public dialog = false;
  public importDialog = false;
  public importOneDialog = false;
  public packageDialog = false;
  public depositChargeDialog = false;
  public withdrawChargeDialog = false;
  public totalRowsCount = 0;
  public pageIndex = 1;
  public totalPageCount = 0;
  public companyId = 0;
  public groupId = 0;
  public productId = 0;
  public pageSize = 25;
  public phoneNumber = '';
  public amount = 0;
  public companies = [];
  public groups = [];
  public packageProducts = [];

  public editedItem = {
    id: 0,
    name: '',
    alarmBalance: 0,
    suspendBalance: 0
  };
  public defaultItem = {
    id: 0,
    name: '',
    alarmBalance: 0,
    suspendBalance: 0
  };

  public importEditedItem = {
    id: 0,
    companyId: 0,
    groupId: 0,
    simList: []
  };
  public importDefaultItem = {
    id: 0,
    companyId: 0,
    groupId: 0,
    simList: []
  };

  public importOneEditItem = {
    id: 0,
    companyId: 0,
    groupId: 0,
    phoneNumber: ''
  };
  public importOneDefaultItem = {
    id: 0,
    companyId: 0,
    groupId: 0,
    phoneNumber: ''
  };

  public chargeItem = {
    id: 0,
    amount: 0
  };

  public transferItem = {
    id: 0,
    companyId: 0,
    amount: 0,
    description: ''
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'مدیریت سیم کارت ها',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
    await Api.getCompanyShortList().then((response: any) => {
      this.companies = response.data;
    });
    await Api.getGroups().then((response: any) => {
      this.groups = response.data;
    });
    await Api.getProducts(2).then((response: any) => {
      this.packageProducts = response.data;
      this.$hideLoading();
    });
  }

  async initialize() {
    await this.getData();
  }

  async getData() {
    this.$showLoading();
    await Api.getSims({
      pageIndex: this.pageIndex - 1,
      pageSize: this.pageSize,
      phoneNumber: this.phoneNumber,
      companyId: this.companyId,
      groupId: this.groupId
    }).then((response: any) => {
      this.desserts = response.data.data;
      this.totalRowsCount = response.data.totalRowsCount;
      this.totalPageCount = Math.ceil(this.totalRowsCount / this.pageSize);
      this.$hideLoading();
    });
  }

  editItem(item: any) {
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  async updateCredit(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید این مورد را بروز کنید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.updateCredit(id).then((response: any) => {
        this.$showNotification('success', 'سیم کارت بروز شد');
        this.close();
        this.$hideLoading();
      });
    }
  }

  async chargeSim(add: boolean) {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    var amountCharge = this.amount;
    if (add) amountCharge = Math.abs(this.amount);
    else amountCharge = -Math.abs(this.amount);

    this.$showLoading();
    await Api.simCharge(this.phoneNumber, this.groupId, amountCharge).then((response: any) => {
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد.');
      this.close();
      this.$hideLoading();
    });
  }

  async packageSim() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.simPackage(this.phoneNumber, this.groupId, this.productId).then((response: any) => {
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد.');
      this.close();
      this.$hideLoading();
    });
  }

  increaseChargeDialog(groupId: number, phoneNumber: string) {
    this.depositChargeDialog = true;
    this.groupId = groupId;
    this.phoneNumber = phoneNumber;
  }

  decreaseChargeDialog(groupId: number, phoneNumber: string) {
    this.withdrawChargeDialog = true;
    this.groupId = groupId;
    this.phoneNumber = phoneNumber;
  }

  addPackageDialog(groupId: number, phoneNumber: string) {
    this.packageDialog = true;
    this.groupId = groupId;
    this.phoneNumber = phoneNumber;
  }

  async importSims() {
    const isValid = (this.$refs.ObserverImport as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.importSims(this.importEditedItem.companyId, this.importEditedItem.groupId, this.importEditedItem.simList).then((response: any) => {
      this.close();
      this.$showNotification('success', 'سیم کارت ها با موفقیت ثبت شد.');
      this.$hideLoading();
    });
  }

  async importOneSims() {
    const isValid = (this.$refs.ObserverOneImport as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.importOneSims(this.importOneEditItem.companyId, this.importOneEditItem.groupId, this.importOneEditItem.phoneNumber).then(
      (response: any) => {
        this.close();
        this.$showNotification('success', 'سیم کارت ها با موفقیت ثبت شد.');
        this.$hideLoading();
      }
    );
  }

  async save() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.editSim(this.editedItem).then((response: any) => {
      this.close();
      this.$showNotification('success', 'سیم کارت بروز شد');
      this.$hideLoading();
    });
  }

  async enableItem(id: number) {
    await Api.enableSim(id).then((response: any) => {
      this.close();
      this.$showNotification('success', 'سیم کارت فعال شد');
      this.$hideLoading();
    });
  }

  async disableItem(id: number) {
    await Api.disableCompany(id).then((response: any) => {
      this.close();
      this.$showNotification('success', 'سیم کارت غیرفعال شد');
      this.$hideLoading();
    });
  }

  async close() {
    this.dialog = false;
    this.importDialog = false;
    this.importOneDialog = false;
    this.packageDialog = false;
    this.depositChargeDialog = false;
    this.withdrawChargeDialog = false;
    this.groupId = 0;
    this.companyId = 0;
    this.phoneNumber = '';
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.importEditedItem = Object.assign({}, this.importDefaultItem);
    });
    this.initialize();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(isDisabled: string) {
    if (isDisabled === 'فعال') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
